"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _constants = require("./constants");

var _sx = _interopRequireDefault(require("./sx"));

var _theme = _interopRequireDefault(require("./theme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Heading = _styledComponents.default.h2.withConfig({
  displayName: "Heading",
  componentId: "sc-1cjoo9h-0"
})(["font-weight:", ";font-size:", ";margin:0;", ";", ";", ";"], (0, _constants.get)('fontWeights.bold'), (0, _constants.get)('fontSizes.5'), _constants.TYPOGRAPHY, _constants.COMMON, _sx.default);

Heading.defaultProps = {
  theme: _theme.default
};
var _default = Heading;
exports.default = _default;